import React from "react"

import { type IconProps } from "./utils"

export default function ToolboxIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.62793 3C5.61874 3 5.61006 3.00417 5.60432 3.01135L4.66728 4.18265C4.56089 4.31564 4.50293 4.48087 4.50293 4.65117V7.5H6.75293V4.65117C6.75293 4.48087 6.69497 4.31563 6.58858 4.18265L5.65154 3.01135C5.6458 3.00418 5.63711 3 5.62793 3ZM8.25293 7.5V4.65117C8.25293 4.14026 8.07905 3.64456 7.75988 3.24561L6.82284 2.0743C6.53245 1.71131 6.09279 1.5 5.62793 1.5C5.16307 1.5 4.72341 1.71131 4.43302 2.0743L3.49597 3.24561C3.17681 3.64456 3.00293 4.14026 3.00293 4.65117V7.5H2.25C1.83579 7.5 1.5 7.83579 1.5 8.25V13.5C1.5 14.7426 2.50736 15.75 3.75 15.75H14.25C15.4926 15.75 16.5 14.7426 16.5 13.5V8.25C16.5 7.83579 16.1642 7.5 15.75 7.5H15V3C15 2.17157 14.3284 1.5 13.5 1.5H10.5C9.67157 1.5 9 2.17157 9 3V7.5H8.25293ZM3 9V13.5C3 13.9142 3.33579 14.25 3.75 14.25H14.25C14.6642 14.25 15 13.9142 15 13.5V9H3ZM10.5 7.5H13.5V3H10.5V4.5H11.2529C11.6671 4.5 12.0029 4.83579 12.0029 5.25C12.0029 5.66421 11.6671 6 11.2529 6H10.5V7.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
